<template>
  <div class="official-home">
    <!-- 顶部导航 -->
<Headers />

    <!-- 英雄区域：使用背景图片 + 文字 + 按钮 -->
    <div class="hero-section">
      <img class="bg-gpu" src="https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1500&q=80" alt="GPU Background" />
      <div class="bg-effect"></div>
      <div class="container">
        <div class="main-title">
          面向AI开发与模型部署的<br/>一站式算力租赁平台
        </div>
        <div class="subtitle">
          极速部署 · 多模型 · 高性价比 · 灵活算力
        </div>
        <div class="btn-group1">
          <button class="main-btn start">
            <a href="https://console.aflops.com/">开发容器</a>
          </button>
          <button class="main-btn info">
            <a href="https://console.aflops.com/">模型部署</a>
          </button>
        </div>
      </div>
    </div>


    <!-- GPU配置对比 -->
    <div class="gpu-comparison">
      <div class="comparison-container">
        <h2>高性价比算力套餐</h2>
        <div class="gpu-grid">
          <!-- RTX 3090 -->
          <div class="gpu-card">
            <div class="gpu-header">
              <h3>RTX 3090</h3>
              <div class="gpu-badge entry">入门首选</div>
            </div>
            <div class="gpu-specs">
              <div class="spec-row">
                <span class="spec-label">显存</span>
                <span class="spec-value">24GB GDDR6</span>
              </div>
              <div class="spec-row">
                <span class="spec-label">单卡算力</span>
                <span class="spec-value">8.1 TFLOPS (FP16)</span>
              </div>
              <div class="spec-row">
                <span class="spec-label">配套CPU/内存</span>
                <span class="spec-value">4vCPU/16GB</span>
              </div>
              <div class="spec-row">
                <span class="spec-label">存储</span>
                <span class="spec-value">100GB SSD</span>
              </div>
              <div class="spec-row">
                <span class="spec-label">适用场景</span>
                <span class="spec-value">推理/轻量训练</span>
              </div>
            </div>
            <div class="gpu-pricing">
              <div class="price-amount">
                ￥{{ billingMode === 'hourly' ? '2.12' : '1,160' }}
              </div>
              <div class="price-unit">{{ billingMode === 'hourly' ? '每卡每小时' : '每卡每月' }}</div>
              <button class="main-btn main-btn-small border-2" @click="selectGPU('rtx3090')">
                <a href="#" >选择配置</a>
              </button>
            </div>
          </div>

          <!-- RTX 4090 -->
          <div class="gpu-card">
            <div class="gpu-header">
              <h3>RTX 4090</h3>
              <div class="gpu-badge balanced">均衡之选</div>
            </div>
            <div class="gpu-specs">
              <div class="spec-row">
                <span class="spec-label">显存</span>
                <span class="spec-value">24GB GDDR6</span>
              </div>
              <div class="spec-row">
                <span class="spec-label">单卡算力</span>
                <span class="spec-value">8.1 TFLOPS (FP16)</span>
              </div>
              <div class="spec-row">
                <span class="spec-label">配套CPU/内存</span>
                <span class="spec-value">64vCPU/512GB</span>
              </div>
              <div class="spec-row">
                <span class="spec-label">存储</span>
                <span class="spec-value">100GB SSD</span>
              </div>
              <div class="spec-row">
                <span class="spec-label">适用场景</span>
                <span class="spec-value">中等规模训练/渲染</span>
              </div>
            </div>
            <div class="gpu-pricing">
              <div class="price-amount">
                ￥{{ billingMode === 'hourly' ? '3.12' : '2,160' }}
              </div>
              <div class="price-unit">{{ billingMode === 'hourly' ? '每卡每小时' : '每卡每月' }}</div>
              <button class="main-btn main-btn-small border-2" @click="selectGPU('rtx4090')">
                <a href="#" >选择配置</a>
              </button>
            </div>
          </div>

          <!-- RTX 5090 -->
          <div class="gpu-card">
            <div class="gpu-header">
              <h3>RTX 5090</h3>
              <div class="gpu-badge premium">性能旗舰</div>
            </div>
            <div class="gpu-specs">
              <div class="spec-row">
                <span class="spec-label">显存</span>
                <span class="spec-value">32GB GDDR6</span>
              </div>
              <div class="spec-row">
                <span class="spec-label">单卡算力</span>
                <span class="spec-value">31.2 TFLOPS (FP16)</span>
              </div>
              <div class="spec-row">
                <span class="spec-label">配套CPU/内存</span>
                <span class="spec-value">64vCPU/512GB</span>
              </div>
              <div class="spec-row">
                <span class="spec-label">存储</span>
                <span class="spec-value">100GB SSD</span>
              </div>
              <div class="spec-row">
                <span class="spec-label">适用场景</span>
                <span class="spec-value">推理/轻量训练</span>
              </div>
            </div>
            <div class="gpu-pricing">
              <div class="price-amount">
                ￥{{ billingMode === 'hourly' ? '4.12' : '3,160' }}
              </div>
              <div class="price-unit">{{ billingMode === 'hourly' ? '每卡每小时' : '每卡每月' }}</div>
              <button class="main-btn main-btn-small border-2" @click="selectGPU('rtx5090')">
                <a href="#" >选择配置</a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 模型类型展示 -->
    <div class="models-section" >
      <div class="models-container" >
        <h2 class="section-title">丰富的大模型镜像支持</h2>
        <el-container class="container">
          <el-main >
            <div class="content-box" >
              <h1 class="title"></h1>

<!--              <div class="desc">
                <p>提供丰富的一键部署镜像，为需要快速验证模型效果的用户提供一站式调用服务。</p>
                <p>模型运行于私人容器，数据不出沙箱，并预装JupyterLab等工具，支持在线调试模型调用代码。</p>
              </div>-->

              <div class="hexagon-container">
                <!-- 第一行（5个六边形） -->
                <div class="hexagon-row">
                  <div
                    v-for="(model, index) in firstRowModels"
                    :key="'first-'+index"
                    class="hexagon"
                    :class="{ highlight: model.highlight }"
                  >
                    <div class="hexagon-inner">
                      <i :class="model.icon" class="hexagon-icon"></i>
                      <div class="hexagon-text">{{ model.name }}</div>
                    </div>
                  </div>
                </div>

                <!-- 第二行（4个六边形） -->
                <div class="hexagon-row">
                  <div
                    v-for="(model, index) in secondRowModels"
                    :key="'second-'+index"
                    class="hexagon"
                    :class="{ highlight: model.highlight }"
                  >
                    <div class="hexagon-inner">
                      <i :class="model.icon" class="hexagon-icon"></i>
                      <div class="hexagon-text">{{ model.name }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-main>
        </el-container>


      </div>
    </div>

    <!-- CTA区域 -->
    <section class="cta-section" >
      <div class="cta-container">
        <h2>开启您的AI创新之旅</h2>
        <p>立即体验业界领先的AI算力云平台</p>
        <div class="cta-actions">
          <button class="main-btn main-btn-small sm2" @click="goToRegister">
            <a href="#" >免费注册</a>
          </button>
          <button class="main-btn main-btn-small sm2" @click="goToProducts">
            <a href="#" >查看产品</a>
          </button>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <Footer />

  </div>
</template>

<script>
import Headers from '@/components/headers.vue'
import Footer from '@/components/footer.vue'
export default {
  name: 'OfficialHome',
  components: {
    Headers,
    Footer
  },
  data() {
    return {
      // 页面数据可以在这里定义
      isScrolled: false,
      isScrolling: false,
      lastScrollTime: 0,
      billingMode: 'hourly',
      currentSectionIndex: 0,
      sections: [
        '.hero-section',
        '.gpu-comparison', 
        '.models-section',
        '.cta-section'
      ],
      models: [
        { name: 'Qwen', highlight: false, icon: 'fas fa-brain' },
        { name: 'Whisper', highlight: false, icon: 'fas fa-assistive-listening-systems' },
        { name: 'Comfy UI', highlight: false, icon: 'fas fa-cogs' },
        { name: 'Spark Lite', highlight: false, icon: 'fas fa-bolt' },
        { name: 'Qwen-VL', highlight: false, icon: 'fas fa-eye' },
        { name: 'deepseek', highlight: false, icon: 'fas fa-search' },
        { name: 'volcengine', highlight: false, icon: 'fas fa-server' },
        { name: 'ChatTTS', highlight: false, icon: 'fas fa-microphone-alt' },
        { name: 'GLM-4', highlight: false, icon: 'fas fa-project-diagram' }
      ],
      positionedModels: [],

      techItems: [
        {
          title: '教育 AI 实验平台',
          description: '平台为高校及科研机构提供即开即用的AI开发环境，支持多人协作与资源共享，让学生和教师能专注于AI技术的实际应用和创新研究，全面提升教学质量与科研效率',
          //image: require('@/assets/image/bg.jpg') // 替换为你的图片路径
          image:'https://pic.rmb.bdstatic.com/bjh/cms/240419/b4af40135ffc2e858a838c5564f94762_1713538961.376_904.png@h_1280'
        },
        {
          title: '电商技术支持',
          description: '平台提供一键部署AI模型服务 + 7×24小时专业技术支持 ，帮助电商企业快速搭建并运行AI应用，无需专业运维团队即可实现智能化升级',
          //image: require('@/assets/image/bg.jpg')
          image:'https://gbres.dfcfw.com/Files/iimage/20250327/555998FBAFC7D4A738418B5B3133E6F2_w3000h2000.jpg'
        },
        {
          title: '智能制造行业',
          description: '借助云算力平台快速部署AI模型，提升生产线的自动化与智能化水平，结合资源按需使用，降低企业IT投入成本',
          //image: require('@/assets/image/bg.jpg')
          image: 'https://img0.baidu.com/it/u=1509312355,1874244676&fm=253&fmt=auto&app=120&f=JPEG?w=1132&h=800'
        },
      ]

    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    window.addEventListener('wheel', this.handleWheel, { passive: false })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('wheel', this.handleWheel)
  },
  computed: {
    // 第一行显示前5个模型
    firstRowModels() {
      return this.models.slice(0, 5);
    },
    // 第二行显示后4个模型
    secondRowModels() {
      return this.models.slice(5);
    }
  },
  methods: {
    goToProducts() {
      this.$router.push('/official/products')
    },
    goToRegister() {
      window.open('/login', '_blank')
    },
    scrollToProducts() {
      this.$refs.productsSection.scrollIntoView({ behavior: 'smooth' })
    },
    onResize() {
      // 响应式处理，如有需要可在此添加
    },
    handleWheel(event) {
      // 防抖处理，避免快速滚动
      const now = Date.now()
      if (now - this.lastScrollTime < 800) {
        event.preventDefault()
        return
      }
      
      if (this.isScrolling) {
        event.preventDefault()
        return
      }
      
      // 检测滚动方向
      const deltaY = event.deltaY
      let targetIndex = this.currentSectionIndex
      
      if (deltaY > 0) {
        // 向下滚动
        targetIndex = Math.min(this.currentSectionIndex + 1, this.sections.length - 1)
      } else {
        // 向上滚动  
        targetIndex = Math.max(this.currentSectionIndex - 1, 0)
      }
      
      // 如果目标索引不同，则切换页面
      if (targetIndex !== this.currentSectionIndex) {
        event.preventDefault()
        this.lastScrollTime = now
        this.goToSection(targetIndex)
      }
    },
    goToSection(index) {
      if (index < 0 || index >= this.sections.length || this.isScrolling) return
      
      this.isScrolling = true
      this.currentSectionIndex = index
      
      const targetElement = document.querySelector(this.sections[index])
      if (targetElement) {
        targetElement.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        })
      }
      
      // 重置滚动状态
      setTimeout(() => {
        this.isScrolling = false
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>


h2 {
    font-size: 36px;
    font-weight: 700;
    text-align: center;
    margin: 0 0 60px;
    color: #ffffff;
  }


.official-home {
  min-height: 100vh;
  background: #000;
  color: #ffffff;
}



// 英雄区域
.hero-section {
  padding: 140px 20px 100px;
  background: radial-gradient(ellipse at center, rgba(102, 126, 234, 0.15) 0%, rgba(10, 14, 26, 1) 70%);
  position: relative;
  overflow: hidden;

  /*.btn-group {
    display: flex;
    justify-content: center;
    gap: 20px;

    .el-button {
      font-size: 16px;
      padding: 14px 32px;
      border-radius: 30px;
      font-weight: 600;
      display: flex;
      align-items: center;
      gap: 8px; !* 图标和文字之间的间距 *!

      i {
        font-size: 18px;
      }
    }

    .primary-btn {
      background: #000; !* 深色背景 *!
      color: #fff; !* 白色文字 *!
      border: none;

      &:hover {
        background: #333; !* 悬浮时稍微变浅 *!
      }
    }

    .secondary-btn {
      background: transparent; !* 透明背景 *!
      color: #fff; !* 白色文字 *!
      border: 2px solid #fff; !* 白色边框 *!

      &:hover {
        background: rgba(255, 255, 255, 0.1); !* 悬浮时背景稍微变暗 *!
      }
    }
  }*/

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="%23ffffff" stroke-width="0.5" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
    opacity: 0.3;
  }

  .hero-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    align-items: center;
    position: relative;
  }

  .hero-content {
    .hero-title {
      font-size: 45px;
      font-weight: 700;
      line-height: 1.2;
      margin: 0 0 24px;

      .hero-subtitle {
        background: white;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    .hero-description {
      font-size: 18px;
      color: #8892b0;
      line-height: 1.6;
      margin: 0 0 40px;
    }

    .hero-actions {
      display: flex;
      gap: 20px;

      .el-button {
        height: 50px;
        padding: 0 32px;
        font-size: 16px;
        font-weight: 600;
        border-radius: 25px;

        &.el-button--primary {
          background: white;
          border: none;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
          }
        }

        &:not(.el-button--primary) {
          background: transparent;
          border: 2px solid rgba(255, 255, 255, 0.2);
          color: #ffffff;

          &:hover {
            background: rgba(255, 255, 255, 0.1);
            border-color: rgba(255, 255, 255, 0.3);
          }
        }
      }
    }
  }

  .hero-visual {
    position: relative;
    height: 400px;

    .floating-elements {
      position: relative;
      width: 100%;
      height: 100%;

      .float-card {
        position: absolute;
        background: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 16px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        animation: float 6s ease-in-out infinite;

        i {
          font-size: 32px;
          background: white;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        span {
          font-weight: 600;
          color: #ffffff;
        }

        &.gpu-card {
          top: 20%;
          left: 10%;
          animation-delay: 0s;
        }

        &.ai-card {
          top: 50%;
          right: 20%;
          animation-delay: 2s;
        }

        &.cloud-card {
          bottom: 20%;
          left: 30%;
          animation-delay: 4s;
        }
      }
    }
  }
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  25% { transform: translateY(-10px) rotate(1deg); }
  50% { transform: translateY(-20px) rotate(0deg); }
  75% { transform: translateY(-10px) rotate(-1deg); }
}



// 框架支持
.frameworks-section {
  padding: 80px 20px;
  background: #1a1f2e;

  .frameworks-container {
    max-width: 1200px;
    margin: 0 auto;
  }


  .frameworks-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 30px;
  }

  .framework-item {
    .framework-icon {
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 16px;
      padding: 40px 20px;
      text-align: center;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
        transform: translateY(-4px);
      }

      span {
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
      }

      &.pytorch span { color: #ff6b35; }
      &.tensorflow span { color: #ff6f00; }
      &.paddlepaddle span { color: #0052cc; }
      &.mindspore span { color: #3f51b5; }
    }
  }
}

// 模型类型
.models-section {
  min-height: max(768px, 100vh);
  padding: 150px 0;
  display: block;

  .models-container {
    max-width: 1200px;
    margin: 0 auto;
    .container{
      max-width: unset;
      min-height:unset;
      margin-top: 0;
      height: fit-content;
      .el-main{
        padding: 0;
        height: fit-content;
      }
    }
  }



  .model-categories {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 30px;
  }

  .model-category {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 24px;

    h3 {
      font-size: 20px;
      font-weight: 700;
      color: #ffffff;
      margin: 0 0 20px;
    }

    .subcategory {
      margin-bottom: 20px;

      h4 {
        font-size: 16px;
        color: #8892b0;
        margin: 0 0 12px;
      }

      .model-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;

        .model-tag {
          background: rgba(102, 126, 234, 0.2);
          color: #667eea;
          padding: 4px 12px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 500;
        }
      }
    }
  }
}

// 性能数据
.performance-section {
  padding: 100px 20px;
  background: #1a1f2e;

  .performance-container {
    max-width: 1200px;
    margin: 0 auto;
  }



  .performance-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
  }

  .stat-card {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 32px;
    text-align: center;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      background: rgba(255, 255, 255, 0.08);
    }

    .stat-number {
      font-size: 32px;
      font-weight: 700;
      color: #667eea;
      margin-bottom: 8px;
    }

    .stat-label {
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
      margin-bottom: 4px;
    }

    .stat-desc {
      color: #8892b0;
      font-size: 14px;
      margin-bottom: 8px;
    }

    .stat-compare {
      color: #667eea;
      font-size: 12px;
      font-weight: 500;
    }
  }
}

// 技术特性
.technology-section {
  padding: 100px 20px;
  display: block;

  .technology-container {
    max-width: 1200px;
    margin: 0 auto;
  }



  .tech-features {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
  }

  .tech-feature {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    padding: 32px;
    text-align: center;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-4px);
      background: rgba(255, 255, 255, 0.08);
    }

    .tech-icon {
      width: 80px;
      height: 80px;
      background: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 20px;

      i {
        font-size: 32px;
        color: white;
      }
    }

    h3 {
      font-size: 20px;
      font-weight: 700;
      color: #ffffff;
      margin: 0 0 12px;
    }

    p {
      color: #8892b0;
      line-height: 1.5;
      margin: 0;
    }
  }
}

// CTA区域
.cta-section {
  padding: 200px 20px;
  background: #0d0d12;
  text-align: center;

  .cta-container {
    max-width: 800px;
    margin: 0 auto;

    h2 {
      font-size: 36px;
      font-weight: 700;
      color: white;
      margin: 0 0 16px;
    }

    p {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.9);
      margin: 0 0 40px;
    }

    .cta-actions {
      display: flex;
      justify-content: center;
      gap: 20px;

      .el-button {
        height: 50px;
        padding: 0 32px;
        font-size: 16px;
        font-weight: 600;
        border-radius: 25px;

        &.el-button--primary {
          background: white;
          color: #667eea;
          border: none;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(255, 255, 255, 0.3);
          }
        }

        &:not(.el-button--primary) {
          background: transparent;
          border: 2px solid rgba(255, 255, 255, 0.5);
          color: white;

          &:hover {
            background: rgba(255, 255, 255, 0.1);
            border-color: white;
          }
        }
      }
    }
  }
}

// 页脚

.cloud-title {
  text-align: center;
  font-size: 2.2rem;
  font-weight: bold;
  margin: 48px 0 32px 0;
  letter-spacing: 2px;
  background: linear-gradient(90deg, #00eaff, #0072ff 80%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.model-cloud {
  position: relative;
  width: 90vw;
  max-width: 1200px;
  min-height: 500px;
  height: 60vh;
  margin: 0 auto 60px auto;
}

.model-item {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 22px 10px 14px;
  border-radius: 30px;
  background: rgba(30, 60, 90, 0.85);
  box-shadow: 0 2px 16px #00eaff33;
  border: 1.5px solid #00eaff55;
  color: #fff;
  font-size: 1.08rem;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.18s, box-shadow 0.18s, background 0.18s;
  z-index: 1;
  user-select: none;
}

.model-item:hover {
  background: linear-gradient(90deg, #00eaff 60%, #0072ff 100%);
  color: #fff;
  transform: scale(1.12) rotate(-2deg);
  box-shadow: 0 4px 32px #00eaff99;
  z-index: 2;
}

.model-logo {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fff2;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.model-logo img {
  width: 22px;
  height: 22px;
  object-fit: contain;
  filter: drop-shadow(0 0 4px #00eaff88);
}

/* 响应式 */
@media (max-width: 700px) {
  .model-item {
    font-size: 0.98rem;
    padding: 8px 14px 8px 10px;
  }

  .model-logo {
    width: 22px;
    height: 22px;
  }

  .model-logo img {
    width: 16px;
    height: 16px;
  }
}

.carousel-card {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  position: relative;
  color: white;
  border-radius: 16px;
  overflow: hidden;
}

.carousel-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.6); /* 半透明背景提升文字可读性 */
  border-radius: 12px;

  h3 {
    font-size: 28px;
    margin-bottom: 12px;
    font-weight: bold;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
  }
}


.container {
  //background: white;
  min-height: 100vh;
  padding: 40px 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.content-box {
  max-width: 1000px;
  margin: 0 auto;
  //background: white;;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.title {
  text-align: center;
  color: #1F2D3D;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 25px;
}

.desc {
  text-align: center;
  line-height: 1.8;
  margin: 0 auto 35px;
  max-width: 780px;
  font-size: 17px;
  color: #8892b0;
  line-height: 1.6;
}

.hexagon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  overflow: visible;
}

.hexagon-row {
  display: flex;
  justify-content: center;
  margin-bottom: 25px;
}

.hexagon-row:last-child {
  margin-bottom: 0;
}

.hexagon {
  position: relative;
  width: 140px;
  height: 160px;
  margin: 0 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: visible;

  // 炫彩边框背景
  &::before {
    content: "";
    position: absolute;
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    background: conic-gradient(from -90deg at 50% 50%, 
      rgba(220, 255, 99, 0.9) 0deg, 
      rgba(123, 244, 226, 0.9) 60deg, 
      rgba(58, 109, 242, 0.9) 120deg, 
      rgba(255, 92, 46, 0.9) 180deg, 
      rgba(255, 190, 38, 0.9) 240deg, 
      rgba(138, 43, 226, 0.9) 300deg,
      rgba(220, 255, 99, 0.9) 360deg);
    clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    z-index: -1;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    transform: translateY(-5px);
    
    .hexagon-inner {
      background: rgba(64, 158, 255, 0.2) !important;
    }
    
    .hexagon-icon {
      background: linear-gradient(135deg, #ffffff, #f0f8ff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    .hexagon-text {
      color: #ffffff !important;
      text-shadow: 0 2px 8px rgba(64, 158, 255, 0.5);
    }
  }
}

.hexagon-inner {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(15, 20, 25, 0.95);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
  z-index: 1;
}

// Highlight状态特殊样式
.hexagon.highlight {
  .hexagon-inner {
    background: rgba(64, 158, 255, 0.2) !important;
  }

  .hexagon-icon {
    background: linear-gradient(135deg, #ffffff, #f0f8ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .hexagon-text {
    color: #ffffff !important;
    text-shadow: 0 2px 8px rgba(64, 158, 255, 0.5);
  }
}

.hexagon-icon {
  font-size: 36px;
  margin-bottom: 10px;
  background: conic-gradient(from -90deg at 50% 50%, 
    #DCFF63 0deg, 
    #7BF4E2 60deg, 
    #3A6DF2 120deg, 
    #FF5C2E 180deg, 
    #FFBE26 240deg, 
    #8A2BE2 300deg,
    #DCFF63 360deg);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}



.hexagon-text {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  max-width: 100px;
  word-break: break-word;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.hexagon:hover .hexagon-text {
  color: #ffffff;
  text-shadow: 0 4px 12px rgba(255, 255, 255, 0.3);
}



.compute-card {
  top: 10%;
  left: 50%;
  animation-delay: 1s;
}

// 响应式
@media (max-width: 768px) {
  .hero-container {
    grid-template-columns: 1fr !important;
    text-align: center;
  }

  .hero-content .hero-title {
    font-size: 32px !important;
  }

  .products-grid {
    grid-template-columns: 1fr !important;
  }

  .header-nav {
    display: none !important;
  }
}


.gpu-comparison {
  min-height: max(768px, 100vh);
  padding: 100px 0;
  display: block;
  overflow: visible;

  .comparison-container {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;


  }


  .gpu-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 32px;
    position: relative;
    z-index: 1;

    // 左上角蓝色圆形背景
    &::before {
      content: "";
      position: absolute;
      top: -200px;
      left: -200px;
      width: 600px;
      height: 600px;
      background: radial-gradient(circle, rgba(138, 43, 226, 0.4) 0%, rgba(138, 43, 226, 0.2) 50%, transparent 70%);

      border-radius: 50%;
      filter: blur(30px);
      z-index: -1;
      pointer-events: none;
    }

    // 右下角紫色圆形背景
    &::after {
      content: "";
      position: absolute;
      bottom: -200px;
      right: -200px;
      width: 600px;
      height: 600px;
      // background: radial-gradient(circle, rgba(34, 197, 94, 0.4) 0%, rgba(34, 197, 94, 0.2) 50%, transparent 70%);
      background: radial-gradient(circle, rgba(58, 109, 242, 0.6) 0%, rgba(58, 109, 242, 0.2) 50%, transparent 70%);

      border-radius: 50%;
      filter: blur(30px);
      z-index: -1;
      pointer-events: none;
    }
  }

  .gpu-card {
    background: rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    padding: 32px;
    transition: all 0.3s ease;
    position: relative;
    overflow: visible;
    z-index: 2;

    // &:hover {
    //   transform: translateY(-8px);
    //   box-shadow: 0 20px 40px rgba(102, 126, 234, 0.1);
    // }

    &.featured {
      border-color: #667eea;
      background: rgba(102, 126, 234, 0.08);

      .gpu-header h3 {
        color: #667eea;
      }
    }

    .gpu-header {
      text-align: center;
      margin-bottom: 24px;
      position: relative;

      h3 {
        font-size: 28px;
        font-weight: 700;
        color: #ffffff;
        margin: 0;
      }

      .gpu-badge {
        position: absolute;
        top: -16px;
        right: -16px;
        padding: 6px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 600;
        color: white;

        &.entry {
          color: #52c41a;
        }

        &.balanced {
          color: #1890ff;
        }

        &.premium {
          color: #722ed1;
        }
      }
    }

    .gpu-specs {
      margin-bottom: 32px;

      .spec-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        .spec-label {
          color: #8892b0;
          font-size: 14px;
        }

        .spec-value {
          color: #ffffff;
          font-weight: 600;
          font-size: 14px;
        }
      }
    }

    .gpu-pricing {
      text-align: center;

      .price-amount {
        font-size: 36px;
        font-weight: 700;
        color: #ffffff;
        margin-bottom: 8px;
      }

      .price-unit {
        color: #fff;
        font-size: 14px;
        margin-bottom: 24px;
      }

      .el-button {
        width: 100%;
        height: 44px;
        border-radius: 22px;
        font-weight: 600;
      }
    }
  }
}



.hero-section {
  position: relative;
  // width: 100%;
  min-height: max(768px, 100vh); // 最小高度限制
  overflow: hidden;
  display: flex;
  align-items: center; // 垂直居中
  justify-content: center; // 水平居中
  text-align: center;
}

.bg-gpu {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; // 自动裁剪，保持比例
  z-index: 0;
}

.bg-effect {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(10, 14, 26, 0.7), rgba(102, 126, 234, 0.4));
  z-index: 1;
}

.container {
  position: relative;
  z-index: 2;
  /*max-width: 800px;*/
  padding: 0 20px;
  color: white;
  text-align: center;
  margin-top: 20%;
}

.main-title {
  font-size: 60px;
  font-weight: 700;
  margin-bottom: 24px;
  background: linear-gradient(90deg, #FFFFFF 10%, #FFFFFF 50%, #FFFFFF 90%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.subtitle {
  font-size: 18px;
  color: #fff;
  // opacity: 0.8;
  margin-bottom: 40px;
}

/*.btn-group {
  display: flex;
  justify-content: center;
  gap: 20px;

  .el-button {
    font-size: 16px;
    padding: 14px 32px;
    border-radius: 30px;
    font-weight: 600;

    &.el-button--primary {
      background: white;
      border: none;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
      }
    }

    &:not(.el-button--primary) {
      background: transparent;
      border: 2px solid rgba(255, 255, 255, 0.5);
      color: white;

      &:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: white;
      }
    }
  }
}*/


.btn-group1 {
  display: flex;
  gap: 22px;
  justify-content: center;
  margin-bottom: 40px;
}

.main-btn {
  padding: 1px;
  font-size: 1.1rem;
  border-radius: 15px;
  border: none;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  position: relative;
  z-index: 2;
  overflow: visible;

  &:hover {
    &:before {
      transform: translateX(10px) !important;
      // width: calc(100% + 10px);
      filter: blur(20px);
      z-index: -2; // 降低 z-index 避免遮挡其他按钮
    }
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: conic-gradient(from -90deg at 50% 50%, 
      rgba(220, 255, 99, 0.6) 0deg, 
      rgba(123, 244, 226, 0.6) 20deg, 
      rgba(58, 109, 242, 0.6) 150deg, 
      rgba(255, 92, 46, 0.6) 200deg, 
      rgba(255, 190, 38, 0.6) 300deg, 
      rgba(220, 255, 99, 0.6) 360deg);
    border-radius: 15px;
    filter: blur(0px);
    z-index: -1;
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  }
  &.main-btn-small {
  //   &:hover {
  //     &:before {
  //       transform: calc(100% + 10px) translateX(10px) !important;
  //       filter: blur(20px);
  //       z-index: -2; // 降低 z-index 避免遮挡其他按钮
  //     }
  // }

    a{
      font-size: 14px;
      font-weight: 600;
      width: 312px;
      height: 44px;
    }
    &.sm2{
      a{
        width: 140px;
        height: 40px;
      }
    }
  }

  a {
    background-color: black;
    font-size: 1.25rem;
    color: white;
    height: 78px;
    width: 238px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    border-radius: 14px;
    z-index: 2;
    text-decoration: none;
    transition: all 0.3s ease;
  }
}
// .main-btn.start {
//   border-image: linear-gradient(90deg, #7faaff, #aeefff, #b6f0c6) 1;
//   box-shadow: 0 2px 16px 0 rgba(126,200,255,0.10);
// }
/*.main-btn.start:hover {
  background: linear-gradient(90deg, #7faaff 0%, #b6f0c6 100%);
  color: #1a233a;
}*/
.main-btn.info {
  border-image: linear-gradient(90deg, #b6c6e6, #7faaff) 1;
  /*color: #b6c6e6;*/
  
  &:hover {
    &:before {
      transform: scale(1.2) translateX(10px); // 向右偏移避免遮挡
      z-index: -3; // 更低的层级
    }
  }
}
/*.main-btn.info:hover {
  background: #1a233a;
  color: #fff;
  border-color: #7faaff;
}*/

</style>
